import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function FilterIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "13.001"}
      height={height || "13.491"}
      viewBox="0 0 13.001 13.491"
    >
      <g id="Icon" transform="translate(-1.5 -0.5)">
        <path
          id="União_1"
          data-name="União 1"
          d="M2.877,11.246H0v-.667H2.878a1.579,1.579,0,0,1,3.087,0H12v.667H5.965a1.579,1.579,0,0,1-3.088,0ZM7.3,6.579H0V5.912H7.3a1.579,1.579,0,0,1,3.087,0H12v.667H10.386a1.58,1.58,0,0,1-3.088,0ZM.983,1.913H0V1.246H.983a1.58,1.58,0,0,1,3.088,0H12v.667H4.07a1.579,1.579,0,0,1-3.087,0Z"
          transform="translate(2 1)"
          fill={color || "#bbb"}
          stroke={color || "#bbb"}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1"
        />
      </g>
    </svg>
  );
}
